// extracted by mini-css-extract-plugin
export default {"Header":"header2_Header__M9VOK","Container":"header2_Container__mp3xk","HeadRow":"header2_HeadRow__HAFWa","Menu":"header2_Menu__uddXi","HeadLoginBU":"header2_HeadLoginBU__NVldY"};